export const styles = {
  container: 'tw-flex tw-items-center tw-gap-3 tw-flex-wrap tw-shrink-0',
  pimsSelect: 'tw-min-w-[160px] tw-max-w-[250px]',
  filterChip:
    'tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-bg-neutral-100 tw-border tw-border-neutral-200 tw-px-3 tw-py-1 tw-text-sm tw-text-neutral-700',
  filterLabel: 'tw-cursor-pointer hover:tw-text-neutral-900',
  filterRemove: 'tw-cursor-pointer tw-text-neutral-400 hover:tw-text-red-500 tw-ml-1 tw-text-xs',
  filtersNote: 'tw-text-xs tw-text-neutral-500 tw-italic tw-w-full tw-mt-1',
};
